// src/link.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LinkIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: "1em",
    shapeRendering: "geometricPrecision",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    viewBox: "0 0 16 16",
    width: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8 2c-.683 0-1.365.078-2.034.235a5.008 5.008 0 00-3.731 3.732 8.902 8.902 0 000 4.066 5.008 5.008 0 003.731 3.732 8.904 8.904 0 004.066 0 5.008 5.008 0 003.732-3.732C13.921 9.364 14 8.683 14 8",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.333 2h2.666m0 0v3.111m0-3.11l-4 4.665",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);

export {
  LinkIcon
};
